var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.clsStyle,attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},[(_vm.icon != '')?_c('nut-icon',{staticClass:"txt-icon",attrs:{"type":_vm.icon,"color":_vm.color}}):_vm._e(),_vm._v(" "),_c('span',{style:({ color: _vm.color })},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }